<template src='./success-key-indicators.html'></template>

<script>
import Vue from 'vue'
import TimeToProjectImplementation from './time-to-project-implementation/TimeToProjectImplementation'
import FundingAdequacyIndicator from './funding-adequacy-indicator/FundingAdequacyIndicator'
import Inactivity from './inactivity/Inactivity'
import { EventBus } from '@/router/bus'
import FileSaver from 'file-saver'

export default {
  components: {
    'time-to-project-implementation': TimeToProjectImplementation,
    'funding-adequacy-indicator': FundingAdequacyIndicator,
    Inactivity
  },
  props: ['project', 'selectedPhase', 'projectCode', 'projectPhaseId'],
  data () {
    return {
      tab: null,
      timeToProjectImplementationData: [],
      inactivityData: [],
      fundingAdequacyIndicatorData: []
    }
  },
  computed: {
    getColor () {
      return this.project.phase === this.selectedPhase.phase ? 'var(--v-cards-base)' : 'var(--v-success-light-base)'
    }
  },
  created () {
    EventBus.$on('reloadTimeToProjectImplementationData', (data) => {
      this.timeToProjectImplementationData = data
    })
    EventBus.$on('reloadInactivityData', (data) => {
      this.inactivityData = data
    })
    EventBus.$on('reloadFundingAdequacyIndicatorData', (data) => {
      this.fundingAdequacyIndicatorData = data
    })
    this.setupPage()
  },
  methods: {
    setupPage () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.successKeyIndicatorGet.replace('{projectCode}', this.projectCode).replace('{projectPhaseId}', this.projectPhaseId))
        .then(
          response => {
            this.logConsole(response)
            this.timeToProjectImplementationData = response.data.payload.map(x => x.timeToProjectImplementation)
            this.inactivityData = response.data.payload.map(x => x.inactivity)
            this.fundingAdequacyIndicatorData = response.data.payload.map(x => x.fundingAdequacyIndicator)
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    exportSuccessKeyIndicators (format) {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.generateSuccessKeyIndicatorsGet.replace('{projectCode}', this.$route.params.projectCode).replace('{phaseId}', this.projectPhaseId) + '?format=' + format, { responseType: 'arraybuffer' })
        .then(
          response => {
            var headers = response.headers
            var blob = new Blob([response.data], {
              type: headers.get('content-type')
            })
            FileSaver.saveAs(blob, this.projectCode + '-kpu.' + format)
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    }
  }
}
</script>
